import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Form, Spinner, Alert } from 'react-bootstrap';
import {
  createInventoryProduct,
  fetchInventoryProductById,
  updateInventoryProduct
} from '../../../services/inventoryProductsService';
import { fetchSalesCategoryById } from '../../../services/salesProductService';
import { fetchStockByProductId } from '../../../services/inventoryStockService';

const AddEditProduct = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>(); // Product ID for editing

  const [formData, setFormData] = useState({
    product_name: '',
    category: ''
  });

  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (id) {
      setLoading(true);
      const loadProduct = async () => {
        try {
          const product = await fetchInventoryProductById(id);
          const category = await fetchSalesCategoryById(product.category);
          // const stockData = await fetchStockByProductId(id);

          setFormData({
            product_name: product.product_name,
            category: product.category
          });
        } catch (error) {
          setError('Failed to load product details.');
        } finally {
          setLoading(false);
        }
      };
      loadProduct();
    }
  }, [id]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);

    try {
      if (id) {
        await updateInventoryProduct(id, formData);
        alert('Product updated successfully');
      } else {
        await createInventoryProduct(formData);
        alert('Product added successfully');
      }
      navigate('/inventory/products/all-products');
    } catch (error) {
      setError('Error submitting product.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="container">
      <h2>{id ? 'Edit' : 'Add'} Product</h2>
      {error && <Alert variant="danger">{error}</Alert>}
      <Form onSubmit={handleSubmit}>
        <Form.Group>
          <Form.Label>Product Name</Form.Label>
          <Form.Control
            type="text"
            name="product_name"
            value={formData.product_name}
            onChange={handleChange}
            required
            disabled={submitting}
          />
        </Form.Group>

        <Form.Group>
          <Form.Label>Category</Form.Label>
          <Form.Control
            type="text"
            name="category"
            value={formData.category}
            onChange={handleChange}
            required
            disabled={submitting}
          />
        </Form.Group>

        <Button type="submit" className="mt-3" disabled={submitting}>
          {submitting ? (
            <Spinner animation="border" size="sm" />
          ) : (
            `${id ? 'Update' : 'Add'} Product`
          )}
        </Button>
      </Form>
    </div>
  );
};

export default AddEditProduct;
